var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ga-page"},[_c('h1',[_vm._v("Google Analytics")]),_c('button',{attrs:{"id":"auth-button","hidden":""},on:{"click":_vm.autorize}},[_vm._v("Authorize")]),_c('button',{on:{"click":_vm.loadData}},[_vm._v("LoadData")])])
}
var staticRenderFns = []

export { render, staticRenderFns }